import React, { useLayoutEffect, useState } from 'react'
import anime from 'animejs'

/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
function ReactAnimeIn(props) {
  const {
    id,
    className,
    style,
    type,
    children,
    explodeOptions,
    control,
    setMeta,
  } = props
  const [state, setState] = useState('')
  const [lastControl, setLastControl] = useState('')
  const [player, setPLayer] = useState({})
  let words = []
  let chars = []
  const explodedChildren = []
  if (props.explode) {
    React.Children.map(children, (child) => {
      if (typeof child === 'string') {
        words = child.split(' ')
        chars = child.split('')
      }
    })

    const options = {
      className: explodeOptions.name,
      style: { display: 'inline-block' },
    }
    if (props.explode === 'characters') {
      chars.forEach((char) => {
        explodedChildren.push(
          React.createElement('span', options, char === ' ' ? '\u00A0' : char)
        )
      })
    } else if (props.explode === 'words') {
      words.forEach((word) => {
        explodedChildren.push(React.createElement('span', options, word))
        explodedChildren.push(React.createElement('span', options, '\u00A0'))
      })
    }
  }

  const Play = (event) => {
    const mode = props[event]
    const { animeConfig } = props
    if (mode === undefined || mode === null) return
    if (mode.length > 1) {
      const config = animeConfig || { easing: 'easeOutExpo', duration: 750 }
      const tl = anime.timeline(config)
      if (setMeta) {
        config.update = () =>
          setMeta({
            progress: tl.progress,
            currentTime: tl.currentTime,
            duration: tl.duration,
          })
      }

      mode.map((anim) =>
        anim?.offset ? tl.add(anim, anim.offset) : tl.add(anim)
      )
      // eslint-disable-next-line consistent-return
      return tl
    }
    mode.map((anim) => anime(anim))
  }

  useLayoutEffect(() => {
    setPLayer(Play('initial'))
  }, [])

  useLayoutEffect(() => {
    if (props[state] === undefined) {
      if (props._onUpdate) {
        Play('_onUpdate')
      }
      if (control) {
        if (lastControl !== control) {
          if (typeof control !== 'object') {
            setLastControl(control)
            player[control]()
          } else {
            setLastControl(control)
            player[control[0]](player.duration * (control[1] / 100))
          }
        }
      }
    } else {
      Play(state)
    }
    setState('')
    return () => {
      if (props._onUnmount) {
        Play('_onUnmount')
      }
    }
  })

  const options = {
    id,
    style,
    className,
    onClick: (e) => {
      if (props._onClick) setState('_onClick')
      try {
        props.onClick(e)
      } catch (ex) {}
    },
    onContextMenu: (e) => {
      if (props._onContextMenu) setState('_onContextMenu')
      try {
        props.onContextMenu(e)
      } catch (ex) {}
    },
    onDoubleClick: (e) => {
      if (props._onDoubleClick) setState('_onDoubleClick')
      try {
        props.onDoubleClick(e)
      } catch (ex) {}
    },
    onDrag: (e) => {
      if (props._onDrag) setState('_onDrag')
      try {
        props.onDrag(e)
      } catch (ex) {}
    },
    onDragEnd: (e) => {
      if (props._onDragEnd) setState('_onDragEnd')
      try {
        props.onDragEnd(e)
      } catch (ex) {}
    },
    onDragEnter: (e) => {
      if (props._onDragEnter) setState('_onDragEnter')
      try {
        props.onDragEnter(e)
      } catch (ex) {}
    },
    onDragExit: (e) => {
      if (props._onDragExit) setState('_onDragExit')
      try {
        props.onDragExit(e)
      } catch (ex) {}
    },
    onDragLeave: (e) => {
      if (props._onDragLeave) setState('_onDragLeave')
      try {
        props.onDragLeave(e)
      } catch (ex) {}
    },
    onDragOver: (e) => {
      if (props._onDragOver) setState('_onDragOver')
      try {
        props.onDragOver(e)
      } catch (ex) {}
    },
    onDragStart: (e) => {
      if (props._onDragStart) setState('_onDragStart')
      try {
        props.onDragStart(e)
      } catch (ex) {}
    },
    onDrop: (e) => {
      if (props._onDrop) setState('_onDrop')
      try {
        props.onDrop(e)
      } catch (ex) {}
    },
    onMouseDown: (e) => {
      if (props._onMouseDown) setState('_onMouseDown')
      try {
        props.onMouseDown(e)
      } catch (ex) {}
    },
    onMouseEnter: (e) => {
      if (props._onMouseEnter) setState('_onMouseEnter')
      try {
        props.onMouseEnter(e)
      } catch (ex) {}
    },
    onMouseLeave: (e) => {
      if (props._onMouseLeave) setState('_onMouseLeave')
      try {
        props.onMouseLeave(e)
      } catch (ex) {}
    },
    onMouseMove: (e) => {
      if (props._onMouseMove) setState('_onMouseMove')
      try {
        props.onMouseMove(e)
      } catch (ex) {}
    },
    onMouseOut: (e) => {
      if (props._onMouseOut) setState('_onMouseOut')
      try {
        props.onMouseOut(e)
      } catch (ex) {}
    },
    onMouseOver: (e) => {
      if (props._onMouseOver) setState('_onMouseOver')
      try {
        props.onMouseOver(e)
      } catch (ex) {}
    },
    onMouseUp: (e) => {
      if (props._onMouseUp) setState('_onMouseUp')
      try {
        props.onMouseUp(e)
      } catch (ex) {}
    },
  }
  return React.createElement(
    type || 'div',
    options,
    props.explode === undefined ? children : explodedChildren
  )
}

const { stagger } = anime
const Anime = ReactAnimeIn

export default Anime
